import React, { useEffect, useState } from 'react';
import { useGlobal } from '../global/GlobalContext';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { cacheManager } from '../utils/cacheManager';
import { useWishlistAddToCart } from '../hooks/useWishlistAddToCart';
import ProductCard from './ProductCard';
import SizeSelectionPopup from './SizeSelectionPopup';
import DistributorQuantityPopup from './DistributorQuantityPopup';

const RecentlyViewed = () => {
  const [recentProducts, setRecentProducts] = useState([]);
  const { token, wishlist, setWishlist } = useGlobal();
  const {
    addingId,
    isSizePopupOpen,
    sizeOptions,
    selectedVariation,
    setSelectedVariation,
    closeSizePopup,
    confirmSize,
    isQtyPopupOpen,
    selectedQuantity,
    setSelectedQuantity,
    popupQuantities,
    getItemPackQty,
    closeQtyPopup,
    confirmQuantity,
    handleAddToCartClick,
    currentItem,
  } = useWishlistAddToCart({ navigateOnSuccess: false });

  useEffect(() => {
    // ProductDetailsAll stores this list via cacheManager under
    // 'fp_recentlyViewedProducts' — this was previously reading raw
    // sessionStorage under a different, unprefixed key ('recentlyViewedProducts'),
    // so it could never actually find the data.
    const viewedProducts = cacheManager.get('fp_recentlyViewedProducts') || [];
    setRecentProducts(Array.isArray(viewedProducts) ? viewedProducts : []);
  }, [token]);

  if (recentProducts.length === 0) return null;

  return (
    <div className="pt-3">
      <h2 className="text-lg font-bold text-gray-900 mb-4">Recently Viewed</h2>

      <Swiper
        navigation
        loop={false}
        breakpoints={{
          360: { slidesPerView: 2.1 },
          640: { slidesPerView: 3.2 },
          768: { slidesPerView: 4 },
          1024: { slidesPerView: 5 },
        }}
        spaceBetween={16}
        modules={[Navigation]}
        className="mySwiper !pb-2"
      >
        {recentProducts.map((product) => (
          <SwiperSlide key={product.id}>
            <ProductCard
              product={product}
              wishlist={wishlist}
              setWishlist={setWishlist}
              token={token}
              onQuickAdd={handleAddToCartClick}
              addingId={addingId}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <SizeSelectionPopup
        open={isSizePopupOpen}
        sizeOptions={sizeOptions}
        selectedVariation={selectedVariation}
        onSelect={setSelectedVariation}
        onClose={closeSizePopup}
        onConfirm={confirmSize}
      />

      <DistributorQuantityPopup
        open={isQtyPopupOpen}
        packQty={getItemPackQty(currentItem, selectedVariation)}
        quantities={popupQuantities}
        selectedQuantity={selectedQuantity}
        onSelect={setSelectedQuantity}
        onClose={closeQtyPopup}
        onConfirm={confirmQuantity}
      />
    </div>
  );
};

export default RecentlyViewed;
